import styled from "styled-components";
import React from "react";
import { ProfileFilters, ProfileMetrics } from "pages/dashboard/profiles/profilefilters";
import { ProfileCard } from "pages/dashboard/profiles/profilecard";
import { ProfileRow } from "pages/dashboard/profiles/profilerow";
import { useProfileState } from "hooks/useProfileState";

const avatarColors = [
  "B0FFC8", "FFE2AC", "B0C7FF", "FFE241",
  "A8FFEB", "D9D9D9", "FFC9C9", "FBCCFF",
  "FFE7B4", "D9D9D9"
];

const statusColors = {
  "registered": "#FFE241",
  "submitted": "#B0C7FF",
  "accepted": "rgb(2, 233, 10)",
  "active": "rgb(2, 233, 10)",
  "rejected": "red",
  "waitlist": "rgb(255, 208, 70)",
  "banned": "black"
};

const getColorFromKey = (key) => {
  const hashKey = key.split('').reduce((acc, char) =>
    acc + char.charCodeAt(0), 0) % avatarColors.length;
  return avatarColors[hashKey];
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 4px;
  text-align: left;
  box-sizing: border-box;
`;

const LeftTable = styled(Container)`
  flex: 2;
  padding: 0px 8px 0px 5px;
  min-width: 0;
  overflow: hidden;
`;

const RightSide = styled(Container)`
  background: #f7f7f7;
  flex: 1;
  border-radius: 15px 3px 3px 3px;
  background: #FFF;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  padding: 13px 15px;
`;

const ProfileHeadings = styled.div`
  padding: 0px 0px 0px 0px;
  margin: 20px 0px 0px 18px;
`;

const ProfilesHeading = styled.div`
  font-size: 24px;
  font-weight: 800;
`;

const ProfileRows = styled.div`
  overflow-y: auto;
  padding-bottom: 300px;
  width: 100%;
  min-width: 0;
  flex: 1;
`;

const MetricsContainer = styled.div`
  transition: all 0.3s ease;
  ${props => props.$isScrolled && `
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  `}
`;

const FlexWrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  height: 100%;
  flex: 1;
`;

export default function ProfileAdmin() {
  const {
    profiles,
    filteredProfiles,
    selectedProfile,
    loading,
    error,
    adminOrgs,
    filterState,
    activeFilters,
    counts,
    setProfiles,
    handleSearch,
    handleFilterChange,
    handleProfileClick,
    setFilterState
  } = useProfileState();

  const [isScrolled, setIsScrolled] = React.useState(false);

  const handleScroll = (event) => {
    const scrollTop = event.target.scrollTop;
    setIsScrolled(scrollTop > 10);
  };

  if (error) return <div>Error: {error}</div>;

  return (
    <FlexWrapper>
      <LeftTable>
        <ProfileFilters
          profiles={profiles}
          filteredProfiles={filteredProfiles}
          onFilterChange={handleFilterChange}
          adminOrgs={adminOrgs}
          onSearch={handleSearch}
          filterState={filterState}
          onFilterStateChange={setFilterState}
          counts={counts}
          setProfiles={setProfiles}
        />
        <MetricsContainer $isScrolled={isScrolled}>
          <ProfileMetrics
            profiles={profiles}
            onFilterChange={handleFilterChange}
            activeFilters={activeFilters}
            counts={counts.metrics}
            compact={isScrolled}
          />
        </MetricsContainer>
        <ProfileRows onScroll={handleScroll}>
          {filteredProfiles && filteredProfiles.map((profile, index) => (
            <ProfileRow
              onClick={() => handleProfileClick(profile)}
              key={index}
              index={index}
              profile={profile}
              selected={profile.id === selectedProfile?.id}
              avatarColor={getColorFromKey(profile.id)}
              statusColors={statusColors}
            />
          ))}
        </ProfileRows>
      </LeftTable>
      <RightSide>
        <ProfileCard
          profiles={profiles}
          setProfiles={setProfiles}
          content={selectedProfile}
          avatarColor={selectedProfile ? getColorFromKey(selectedProfile.id) : null}
          statusColors={statusColors}
        />
      </RightSide>
    </FlexWrapper>
  );
}
